import { ICommand } from '../../../models/commands/ICommand';
import { Facet } from '../../../models/Facet';
import { uploadFileCommand } from './uploadFileCommand';
import { uploadFolderCommand } from './uploadFolderCommand';
import CommandStrings from '../Commands.resx';
import { PlatformDetection } from '@ms/utilities-browser/lib/PlatformDetection';

const platform = new PlatformDetection();

export const uploadCommand: ICommand = {
  key: new Facet('upload').id,
  automationId: 'uploadCommand',
  name: CommandStrings.Upload,
  title: CommandStrings.UploadCommandTooltip,
  iconProps: {
    iconName: 'upload'
  },
  action: platform.isFolderUploadSupported ? undefined : uploadFileCommand.action,
  subMenuProps: platform.isFolderUploadSupported ? {
    items: [uploadFileCommand, uploadFolderCommand]
  } : undefined
};
